import styled from '@emotion/styled';
import { Badge } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

export const PromotionalBadge = styled(Badge)`
  ${themeGet('badge')}
`;
